var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFontBold = function SvgFontBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.67 10.84q0 1.06-.54 1.9-.54.82-1.46 1.3-.9.46-1.98.46h-6.7V.3h6.84q1.001 0 1.72.54.742.52 1.12 1.36.401.82.4 1.72 0 1.06-.54 1.96t-1.5 1.34q1.221.36 1.92 1.34.72.98.72 2.28m-1.4-.24q0-.72-.32-1.32a2.66 2.66 0 0 0-.88-1 2.1 2.1 0 0 0-1.24-.38H1.39v5.38h5.3q.72 0 1.3-.38.582-.38.92-.98.36-.62.36-1.32M1.39 1.52v5.24h4.88q.701 0 1.24-.36.541-.38.86-.98.32-.6.32-1.28 0-.72-.3-1.3-.299-.6-.82-.96t-1.18-.36z"
  })));
};
export default SvgFontBold;